import { render, staticRenderFns } from "./BillHouseList.vue?vue&type=template&id=2bbf2a8d&scoped=true"
import script from "./BillHouseList.vue?vue&type=script&lang=js"
export * from "./BillHouseList.vue?vue&type=script&lang=js"
import style0 from "./BillHouseList.vue?vue&type=style&index=0&id=2bbf2a8d&prod&scoped=true&lang=css"
import style1 from "./BillHouseList.vue?vue&type=style&index=1&id=2bbf2a8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf2a8d",
  null
  
)

export default component.exports